import React from 'react';
import i18n from '../../utils/i18n';
import A from '@adsk/bim360-matrix-react-a';
import EmptyState from '@adsk/bim360-matrix-react-empty-state';

const ProjectSetupInProgressPlaceholder = () => {
  const icon = Object.assign({}, EmptyState.Icons.NO_PROJECTS, {
    height: '240px',
    width: '280px'
  });
  return (
    <div className="ProjectSetupInProgressPlaceholder">
      <EmptyState
        icon={icon}
        text={i18n.t('project.inactiveState.settingUp')}
        footer={<span className="ProjectSetupInProgressPlaceholder__footer">
          {i18n.t('project.inactiveState.suggestion1')}{' '}
          <A href="." className="ProjectSetupInProgressPlaceholder__footer-link">
            {i18n.t('project.inactiveState.suggestion2')}
          </A>
        </span>}
      />
    </div>
  );
};

ProjectSetupInProgressPlaceholder.displayName = 'ProjectSetupInProgressPlaceholder';

export default ProjectSetupInProgressPlaceholder;
